import api from './api';

const adminBreedService = {
  // Get all breeds (includes inactive ones for admin)
  getBreeds: async (params = {}) => {
    try {
      const response = await api.get('/pets/admin/breeds/', { params });
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || error.message || 'Failed to fetch breeds'
      };
    }
  },

  // Create new breed
  createBreed: async (data) => {
    try {
      const response = await api.post('/pets/admin/breeds/', data);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || error.message || 'Failed to create breed'
      };
    }
  },

  // Update breed
  updateBreed: async (id, data) => {
    try {
      const response = await api.patch(`/pets/admin/breeds/${id}/`, data);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || error.message || 'Failed to update breed'
      };
    }
  },

  // Delete breed
  deleteBreed: async (id) => {
    try {
      await api.delete(`/pets/admin/breeds/${id}/`);
      return { success: true };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || error.message || 'Failed to delete breed'
      };
    }
  }
};

export default adminBreedService;
